// extracted by css-extract-rspack-plugin
var _1 = "g";
var _2 = "p2";
var _3 = "b";
var _4 = "p3";
var _5 = "f";
export { _1 as "inner", _2 as "mainLoadingComponent", _3 as "modalComponent", _4 as "modalMainLoading", _5 as "wrapper" }
